import getRtcStatsReportAdapter from './get_rtc_stats_report_adapter';
import createRtcStatsReportParser from './createRtcStatsReportParser';

// This returns the array-ified list of stats our users are accustomed to
export default (peerConnection, track, completion) => {
  const hasCompletion = typeof completion === 'function';
  const callback = hasCompletion ? completion : () => {};

  const promise = new Promise((resolve, reject) => {
    getRtcStatsReportAdapter(peerConnection, track, (err, rtcStatsReport) => {
      if (err) {
        callback(err);
        reject(err);
        return;
      }
      const parsedReport = createRtcStatsReportParser()(rtcStatsReport);
      callback(null, parsedReport);
      resolve(parsedReport);
    });
  });

  if (hasCompletion) {
    promise.catch(() => {});
  }

  return promise;
};
